import React, { FC, useEffect, useState } from 'react';

import './styles.css';
import { useAuthStore } from '../../../../../store/auth/auth';
import { useNavigate } from 'react-router-dom';
import { useSelectedLayout } from '../../../../../store/useSelectedLayout';
import { LayoutType } from '../../../../../types/LayoutType';
import img from '../../../../../components/layouts/camera/Video.png';
import { Card } from 'antd';
import { PREVIEW_URL, VIDEO_PREVIEW_URL } from '../../../../../const/const';
import IconOnline from '../../../../../components/icons/iconOnline/IconOnline';
import IconOffline from '../../../../../components/icons/iconOffline/IconOffline';
import { Device } from '../../../../../types/Device';
import { ReactComponent as CircleImg } from 'utils/app/assets/icons/circle.svg';

interface LayoutComponentDeviceProps {
    device: Device;
    layout: LayoutType;
}

const LayoutComponentDevice: FC<LayoutComponentDeviceProps> = ({ device, layout }) => {
    const { SmartDVRToken, user } = useAuthStore.getState();
    const navigate = useNavigate();
    const { selectedLayout, setSelectedLayout } = useSelectedLayout();
    const [mediaUrl, setMediaUrl] = useState<string>('');

    const handleDeviceClick = (layout: LayoutType) => {
        navigate(`/layout/${layout.uid}`);
        setSelectedLayout(layout);
    };

    const handleError = (e: any) => {
        e.target.src = img; // Устанавливаем локальную картинку при ошибке загрузки
    };

    useEffect(() => {
        const loadMedia = async () => {
            try {
                if (!device?.UID || !SmartDVRToken) return;

                const response = await fetch(PREVIEW_URL(device.UID), {
                    headers: {
                        SmartDVRLogin: user?.login || '',
                        SmartDVRToken: SmartDVRToken,
                    },
                });

                if (!response.ok) throw new Error('Failed to fetch media');

                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                setMediaUrl(url);
            } catch (error) {
                console.error('Error fetching media:', error);
                setMediaUrl(img);
            }
        };

        loadMedia();

        return () => {
            if (mediaUrl && mediaUrl !== img) {
                URL.revokeObjectURL(mediaUrl);
            }
        };
    }, [device?.UID, SmartDVRToken, user?.login]);

    return (
        <div className="containerDeviceLayout" onClick={() => handleDeviceClick(layout)}>
            <div className="coverDeviceLayout">
                <Card
                    className="DeviceLayout"
                    key={device?.ID}
                    cover={<img className="image imageBig" alt={''} src={mediaUrl || img} />}
                    onError={handleError}
                />
            </div>
            <div className="propertiesDeviceLayout">
                <span className="nameDeviceLayout">
                    <div className="iconDeviceLayout">
                        {device?.online ? (
                            <CircleImg style={{ fill: '#5ABEA6' }} />
                        ) : (
                            <CircleImg style={{ fill: 'red' }} />
                        )}
                    </div>
                    <span className="deviceName_Layout title large">{device?.name}</span>
                </span>
            </div>
        </div>
    );
};

export default LayoutComponentDevice;
